import { HttpParams } from '@angular/common/http';

export const getParams = <P>(rawParams: P): HttpParams => {
  return toHttpParams(rawParams as Record<string, unknown>);
};

export const toHttpParams = (
  payload?: Record<string, unknown>,
): HttpParams | undefined => {
  if (!payload) return undefined;

  let params = new HttpParams();

  Object.entries(payload).forEach(([key, value]) => {
    if (value == null) return;

    if (Array.isArray(value)) {
      value.forEach((item) => {
        params = params.append(key, String(item));
      });
      return;
    }

    params = params.append(key, String(value));
  });

  return params;
};

export enum EParam {
  DRIVER_ID = 'ZHJpdmVySWQ',
  VEHICLE_ID = 'dmVoaWNsZUlk',
}
